import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ArrowLeft, Building2, Shield, FileText, Lock } from 'lucide-react';

const KVKK_CONTENT = `
## KVKK Ayd\u0131nlatma Metni

### 1. Veri Sorumlusu

6698 say\u0131l\u0131 Ki\u015fisel Verilerin Korunmas\u0131 Kanunu ("KVKK") uyar\u0131nca, ki\u015fisel verileriniz; veri sorumlusu olarak \u00d6demeTakip platformu ("Platform") taraf\u0131ndan a\u015fa\u011f\u0131da a\u00e7\u0131klanan kapsamda i\u015flenebilecektir.

**Veri Sorumlusu:** \u00d6demeTakip
**E-posta:** info@odemetakibi.com
**Telefon:** +90 216 606 99 24

### 2. Ki\u015fisel Verilerin \u0130\u015flenme Amac\u0131

Toplanan ki\u015fisel verileriniz, KVKK\u2019nin 5. ve 6. maddelerinde belirtilen ki\u015fisel veri i\u015fleme \u015fartlar\u0131 ve ama\u00e7lar\u0131 d\u00e2hilinde a\u015fa\u011f\u0131daki ama\u00e7larla i\u015flenecektir:

- \u00dcyelik kayd\u0131n\u0131n olu\u015fturulmas\u0131 ve hesap y\u00f6netimi
- Hizmet sunumu ve operasyonel faaliyetlerin y\u00fcr\u00fct\u00fclmesi
- \u00d6deme s\u00f6z\u00fc takibi ve tahsilat hat\u0131rlatma hizmetlerinin sa\u011flanmas\u0131
- WhatsApp \u00fczerinden mesaj g\u00f6nderim hizmetlerinin y\u00fcr\u00fct\u00fclmesi
- M\u00fc\u015fteri ili\u015fkileri y\u00f6netimi ve ileti\u015fim faaliyetleri
- Abonelik ve fatura i\u015flemlerinin ger\u00e7ekle\u015ftirilmesi
- Yasal y\u00fck\u00fcml\u00fcl\u00fcklerin yerine getirilmesi
- Platform g\u00fcvenli\u011finin sa\u011flanmas\u0131
- \u0130statistiksel analizler ve raporlama

### 3. \u0130\u015flenen Ki\u015fisel Veriler

**Kimlik Bilgileri:** Ad, soyad, vergi numaras\u0131, vergi dairesi
**\u0130leti\u015fim Bilgileri:** E-posta adresi, telefon numaras\u0131, adres
**Firma Bilgileri:** Firma ad\u0131, firma telefonu, firma adresi, fatura bilgileri
**M\u00fc\u015fteri Bilgileri:** Cari hesap ad\u0131, m\u00fc\u015fteri telefon numaras\u0131, \u00f6deme bilgileri
**\u0130\u015flem Bilgileri:** \u00d6deme s\u00f6z\u00fc tutarlar\u0131, vade tarihleri, \u00f6deme durumlar\u0131
**Abonelik Bilgileri:** Se\u00e7ilen paket, abonelik ba\u015flang\u0131\u00e7/biti\u015f tarihleri, \u00f6deme y\u00f6ntemi

### 4. WhatsApp Entegrasyonu Hakk\u0131nda

\u00d6demeTakip platformu, WhatsApp mesaj g\u00f6nderimi konusunda yaln\u0131zca bir arac\u0131 hizmet sa\u011flamaktad\u0131r.

- **M\u00fc\u015fterilerinizin WhatsApp hesaplar\u0131na eri\u015fim sa\u011flanmamaktad\u0131r.** Platform, yaln\u0131zca sizin belirledi\u011finiz telefon numaralar\u0131na, sizin onaylad\u0131\u011f\u0131n\u0131z mesaj \u015fablonlar\u0131 \u00fczerinden hat\u0131rlatma mesaj\u0131 g\u00f6ndermektedir.
- **M\u00fc\u015fterilerinizin WhatsApp mesajlar\u0131na, sohbet ge\u00e7mi\u015flerine veya ki\u015fisel i\u00e7eriklerine hi\u00e7bir \u015fekilde eri\u015fim imk\u00e2n\u0131m\u0131z bulunmamaktad\u0131r.**
- WhatsApp ba\u011flant\u0131s\u0131, QR kod ile sizin cihaz\u0131n\u0131z \u00fczerinden ger\u00e7ekle\u015ftirilmekte olup, yaln\u0131zca mesaj g\u00f6nderim amac\u0131yla kullan\u0131lmaktad\u0131r.
- G\u00f6nderilen mesajlar\u0131n i\u00e7erik kay\u0131tlar\u0131 yaln\u0131zca g\u00f6nderim logu olarak tutulmaktad\u0131r.

### 5. Ki\u015fisel Verilerin Aktar\u0131lmas\u0131

Ki\u015fisel verileriniz a\u015fa\u011f\u0131daki hizmet sa\u011flay\u0131c\u0131larla payla\u015f\u0131labilir:

- **\u00d6deme Arac\u0131l\u0131\u011f\u0131:** PayTR (\u00f6deme i\u015flemleri i\u00e7in)
- **Sunucu Sa\u011flay\u0131c\u0131s\u0131:** Vulut.com (hosting ve altyap\u0131 hizmetleri)
- **WhatsApp:** Mesaj g\u00f6nderim altyap\u0131s\u0131 (yaln\u0131zca mesaj iletimi)
- Yasal zorunluluklar kapsam\u0131nda kamu kurum ve kurulu\u015flar\u0131na

### 6. Veri Sahibinin Haklar\u0131

KVKK\u2019nin 11. maddesi uyar\u0131nca haklar\u0131n\u0131z:

- Ki\u015fisel verilerinizin i\u015flenip i\u015flenmedi\u011fini \u00f6\u011frenme
- \u0130\u015flenmisse buna ili\u015fkin bilgi talep etme
- Eksik veya yanl\u0131\u015f i\u015flenmisse d\u00fczeltilmesini isteme
- KVKK\u2019nin 7. maddesinde \u00f6ng\u00f6r\u00fclen \u015fartlar \u00e7er\u00e7evesinde silinmesini isteme
- Kanuna ayk\u0131r\u0131 olarak i\u015flenmesi sebebiyle zarara u\u011framan\u0131z h\u00e2linde zarar\u0131n giderilmesini talep etme

### 7. Veri G\u00fcvenli\u011fi

Platform, ki\u015fisel verilerinizin g\u00fcvenli\u011fini sa\u011flamak amac\u0131yla gerekli teknik ve idari tedbirleri almaktad\u0131r:

- SSL/TLS \u015fifreleme ile veri iletimi
- \u015eifreler bcrypt hash algoritmas\u0131 ile saklan\u0131r
- Eri\u015fim yetkilendirme ve \u00e7ok katmanl\u0131 kimlik do\u011frulama

### 8. Veri Saklama S\u00fcresi

Ki\u015fisel verileriniz, hizmet ili\u015fkisi devam etti\u011fi s\u00fcrece ve yasal saklama y\u00fck\u00fcml\u00fcl\u00fckleri kapsam\u0131nda saklan\u0131r. \u00dcyeli\u011finizin sona ermesi h\u00e2linde hesap verileri 30 g\u00fcn i\u00e7inde silinir, muhasebe verileri yasal zorunluluk gere\u011fi 10 y\u0131l saklan\u0131r.

### 9. \u0130leti\u015fim

KVKK kapsam\u0131ndaki t\u00fcm talep ve sorular\u0131n\u0131z i\u00e7in:

**E-posta:** info@odemetakibi.com
**Telefon:** +90 216 606 99 24
**WhatsApp:** +90 216 606 99 24

Ba\u015fvurular\u0131n\u0131z en ge\u00e7 30 g\u00fcn i\u00e7inde \u00fccretsiz olarak sonu\u00e7land\u0131r\u0131lacakt\u0131r.

Bu ayd\u0131nlatma metni en son 03.03.2026 tarihinde g\u00fcncellenmi\u015ftir.
`;

const PRIVACY_CONTENT = `
## Gizlilik Politikas\u0131

### 1. Giri\u015f

Bu gizlilik politikas\u0131, \u00d6demeTakip platformunun kullan\u0131c\u0131lar\u0131n\u0131n ki\u015fisel verilerinin nas\u0131l topland\u0131\u011f\u0131n\u0131, kullan\u0131ld\u0131\u011f\u0131n\u0131 ve korundu\u011funu a\u00e7\u0131klamaktad\u0131r.

**E-posta:** info@odemetakibi.com
**Telefon:** +90 216 606 99 24

### 2. Toplanan Bilgiler

**Kay\u0131t Bilgileri:** Ad, soyad, e-posta, telefon, firma bilgileri, vergi numaras\u0131
**Fatura Bilgileri:** Fatura adresi, vergi bilgileri, \u00f6deme y\u00f6ntemi tercihi
**Kullan\u0131m Bilgileri:** \u00d6deme s\u00f6zleri, m\u00fc\u015fteri kay\u0131tlar\u0131, mesaj \u015fablonlar\u0131 ve g\u00f6nderim ge\u00e7mi\u015fi
**Teknik Bilgiler:** IP adresi, taray\u0131c\u0131 t\u00fcr\u00fc, oturum \u00e7erezleri

### 3. WhatsApp Mesaj Hizmeti

**\u00d6demeTakip, m\u00fc\u015fterilerinizin WhatsApp hesaplar\u0131na eri\u015fim sa\u011flamamaktad\u0131r.**

- Platform yaln\u0131zca bir arac\u0131 API olarak \u00e7al\u0131\u015fmaktad\u0131r
- M\u00fc\u015fterilerinizin ki\u015fisel WhatsApp mesajlar\u0131n\u0131, sohbet ge\u00e7mi\u015flerini g\u00f6remeyiz ve bunlara eri\u015femeyiz
- WhatsApp ba\u011flant\u0131s\u0131 QR kod ile sizin cihaz\u0131n\u0131z \u00fczerinden kurulmaktad\u0131r
- G\u00f6nderilen mesaj loglar\u0131 hizmet kalitesi i\u00e7in saklan\u0131r, \u00fc\u00e7\u00fcnc\u00fc taraflarla payla\u015f\u0131lmaz

### 4. Hizmet Sa\u011flay\u0131c\u0131lar\u0131m\u0131z

- **\u00d6deme Arac\u0131l\u0131\u011f\u0131:** PayTR - Kredi kart\u0131 \u00f6deme i\u015flemleri i\u00e7in
- **Sunucu Sa\u011flay\u0131c\u0131s\u0131:** Vulut.com - Hosting ve altyap\u0131 hizmetleri
- **WhatsApp:** Mesaj g\u00f6nderim altyap\u0131s\u0131

T\u00fcm hizmet sa\u011flay\u0131c\u0131lar\u0131yla gizlilik s\u00f6zle\u015fmeleri imzalanm\u0131\u015f olup, verileriniz yaln\u0131zca hizmetin gerektirdi\u011fi asgari d\u00fczeyle s\u0131n\u0131rl\u0131 tutulmaktad\u0131r.

### 5. Veri G\u00fcvenli\u011fi

- T\u00fcm veri iletimi SSL/TLS ile \u015fifrelenir
- \u015eifreler bcrypt hash algoritmas\u0131 ile saklan\u0131r
- Eri\u015fim kontrolleri ve rol bazl\u0131 yetkilendirme uygulan\u0131r

### 6. Veri Saklama S\u00fcresi

- Hesap verileri: \u00dcyelik s\u00fcresi + 30 g\u00fcn
- Fatura verileri: 10 y\u0131l (yasal zorunluluk)
- Mesaj g\u00f6nderim loglar\u0131: 2 y\u0131l

### 7. \u0130leti\u015fim

**E-posta:** info@odemetakibi.com
**Telefon:** +90 216 606 99 24
**WhatsApp:** +90 216 606 99 24

Son g\u00fcncelleme: 03.03.2026
`;

const MEMBERSHIP_CONTENT = `
## \u00dcyelik S\u00f6zle\u015fmesi

### 1. Taraflar

Bu s\u00f6zle\u015fme, \u00d6demeTakip platformunu i\u015fleten \u015firket ("Hizmet Sa\u011flay\u0131c\u0131") ile Platform'a kay\u0131t olan ger\u00e7ek veya t\u00fczel ki\u015fi ("\u00dcye") aras\u0131nda, \u00fcyelik kayd\u0131n\u0131n tamamlanmas\u0131 ile y\u00fcr\u00fcrl\u00fc\u011fe girer.

**E-posta:** info@odemetakibi.com
**Telefon:** +90 216 606 99 24

### 2. Hizmetin Tan\u0131m\u0131

Platform, i\u015fletmelere y\u00f6nelik \u015fu hizmetleri sunmaktad\u0131r:

- \u00d6deme s\u00f6z\u00fc olu\u015fturma, takip etme ve y\u00f6netme
- M\u00fc\u015fteri kay\u0131t ve y\u00f6netim sistemi
- WhatsApp \u00fczerinden otomatik ve manuel hat\u0131rlatma mesaj\u0131 g\u00f6nderimi
- Dashboard, raporlama ve analiz ara\u00e7lar\u0131
- Personel y\u00f6netimi ve rol bazl\u0131 yetkilendirme
- Abonelik ve paket y\u00f6netimi

### 3. Deneme S\u00fcresi

- Kay\u0131t olan her firma 7 g\u00fcn \u00fccretsiz deneme hakk\u0131na sahiptir
- Deneme s\u00fcresinde Platform\u2019un t\u00fcm \u00f6zellikleri kullan\u0131labilir
- Deneme s\u00fcresi sonunda \u00fccretli abonelik sat\u0131n al\u0131nmas\u0131 gerekmektedir

### 4. Abonelik ve \u00dccretlendirme

- Abonelik paketleri ve \u00fccretleri Platform \u00fczerinde ilan edilir
- Abonelik s\u00fcresi y\u0131ll\u0131k olarak belirlenir
- \u00d6demeler kredi kart\u0131 (PayTR arac\u0131l\u0131\u011f\u0131yla) veya havale/EFT ile al\u0131n\u0131r
- Kredi kart\u0131 ile yap\u0131lan \u00f6demelerde abonelik hemen ba\u015flat\u0131l\u0131r
- Havale/EFT ile yap\u0131lan \u00f6demelerde, \u00f6demenin onaylanmas\u0131n\u0131n ard\u0131ndan abonelik ba\u015flat\u0131l\u0131r

### 5. WhatsApp Entegrasyonu

- Platform, WhatsApp mesaj g\u00f6nderiminde yaln\u0131zca bir arac\u0131 hizmet sa\u011flamaktad\u0131r
- **M\u00fc\u015fterilerinizin WhatsApp hesaplar\u0131na, mesajlar\u0131na ve ki\u015fisel i\u00e7eriklerine hi\u00e7bir \u015fekilde eri\u015fim sa\u011flanmamaktad\u0131r**
- WhatsApp ba\u011flant\u0131s\u0131 QR kod ile sizin cihaz\u0131n\u0131z \u00fczerinden ger\u00e7ekle\u015ftirilir
- G\u00f6nderilen mesajlar yaln\u0131zca sizin olu\u015fturdu\u011funuz \u015fablonlarla s\u0131n\u0131rl\u0131d\u0131r

### 6. \u00dcyenin Y\u00fck\u00fcml\u00fcl\u00fckleri

- Platform\u2019u yaln\u0131zca yasal ama\u00e7larla kullanmak
- Spam veya rahatsiz edici i\u00e7erik g\u00f6ndermemek
- Hesap bilgilerini gizli tutmak
- G\u00f6nderilen mesajlar\u0131n i\u00e7eri\u011finden sorumlu olmak
- M\u00fc\u015fterilerden mesaj g\u00f6nderimi i\u00e7in gerekli izinleri alm\u0131\u015f olmak

### 7. Hizmet Sa\u011flay\u0131c\u0131lar

- **\u00d6deme Arac\u0131l\u0131\u011f\u0131:** PayTR
- **Sunucu Sa\u011flay\u0131c\u0131s\u0131:** Vulut.com

### 8. S\u00f6zle\u015fmenin Feshi

- \u00dcye, diledi\u011fi zaman hesab\u0131n\u0131 kapatarak s\u00f6zle\u015fmeyi feshedebilir
- A\u011f\u0131r ihlallerde \u00fcyelik derhal sonland\u0131r\u0131labilir
- Fesih durumunda veriler 30 g\u00fcn i\u00e7inde silinir

### 9. Uyu\u015fmazl\u0131k \u00c7\u00f6z\u00fcm\u00fc

Bu s\u00f6zle\u015fmeden do\u011fan uyu\u015fmazl\u0131klarda \u0130stanbul Mahkemeleri ve \u0130cra Daireleri yetkilidir.

### 10. \u0130leti\u015fim

**E-posta:** info@odemetakibi.com
**Telefon:** +90 216 606 99 24
**WhatsApp:** +90 216 606 99 24

Son g\u00fcncelleme: 03.03.2026
`;

const TABS_DATA = {
  kvkk: { title: 'KVKK Ayd\u0131nlatma Metni', icon: Shield, content: KVKK_CONTENT },
  gizlilik: { title: 'Gizlilik Politikas\u0131', icon: Lock, content: PRIVACY_CONTENT },
  uyelik: { title: '\u00dcyelik S\u00f6zle\u015fmesi', icon: FileText, content: MEMBERSHIP_CONTENT },
};

export default function LegalPage() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const activeTab = TABS_DATA[tab] ? tab : 'kvkk';

  const renderMarkdown = (content) => {
    return content.split('\n').map((line, i) => {
      if (line.startsWith('## ')) return <h2 key={i} className="text-xl font-bold mt-8 mb-4 text-foreground">{line.replace('## ', '')}</h2>;
      if (line.startsWith('### ')) return <h3 key={i} className="text-lg font-semibold mt-6 mb-3 text-foreground">{line.replace('### ', '')}</h3>;
      if (line.startsWith('- ')) return <li key={i} className="ml-4 text-sm text-muted-foreground leading-relaxed">{line.replace('- ', '')}</li>;
      if (line.startsWith('**') && line.endsWith('**')) return <p key={i} className="font-semibold text-sm mt-2 text-foreground">{line.replace(/\*\*/g, '')}</p>;
      if (line.startsWith('**')) {
        const parts = line.split('**');
        return <p key={i} className="text-sm text-muted-foreground leading-relaxed mt-1"><strong className="text-foreground">{parts[1]}</strong>{parts[2]}</p>;
      }
      if (line.trim() === '') return <div key={i} className="h-2" />;
      return <p key={i} className="text-sm text-muted-foreground leading-relaxed">{line}</p>;
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-4xl items-center justify-between px-4">
          <Link to="/" className="flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-primary-foreground">
              <Building2 className="h-4 w-4" />
            </div>
            <span className="font-heading font-bold notranslate" translate="no">ÖdemeTakip</span>
          </Link>
          <Button variant="ghost" size="sm" onClick={() => window.history.length > 1 ? navigate(-1) : navigate('/')} data-testid="legal-back-btn">
            <ArrowLeft className="mr-1.5 h-4 w-4" />
            Geri
          </Button>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-8">
        <Tabs value={activeTab} onValueChange={(v) => navigate(`/legal/${v}`, { replace: true })}>
          <TabsList className="grid w-full grid-cols-3 mb-8" data-testid="legal-tabs">
            <TabsTrigger value="kvkk" className="gap-1.5 text-xs sm:text-sm" data-testid="legal-tab-kvkk">
              <Shield className="h-3.5 w-3.5 hidden sm:inline" />
              KVKK
            </TabsTrigger>
            <TabsTrigger value="gizlilik" className="gap-1.5 text-xs sm:text-sm" data-testid="legal-tab-gizlilik">
              <Lock className="h-3.5 w-3.5 hidden sm:inline" />
              Gizlilik
            </TabsTrigger>
            <TabsTrigger value="uyelik" className="gap-1.5 text-xs sm:text-sm" data-testid="legal-tab-uyelik">
              <FileText className="h-3.5 w-3.5 hidden sm:inline" />
              {"Üyelik"}
            </TabsTrigger>
          </TabsList>

          {Object.entries(TABS_DATA).map(([key, data]) => (
            <TabsContent key={key} value={key}>
              <Card>
                <CardContent className="p-4 sm:p-8">
                  {renderMarkdown(data.content)}
                </CardContent>
              </Card>
            </TabsContent>
          ))}
        </Tabs>
      </main>
    </div>
  );
}
